import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import '@/locales/i18n'

// Google Maps deprecation 경고 필터링
const originalWarn = console.warn;
const originalError = console.error;

console.warn = (...args) => {
    const message = args.join(' ');
    // Google Maps 관련 경고 필터링
    if (message.includes('google.maps.Marker is deprecated') || 
        message.includes('google.maps.marker.AdvancedMarkerElement') ||
        message.includes('As of February 21st, 2024, google.maps.Marker is deprecated') ||
        message.includes('Google Maps JavaScript API warning: RetiredVersion') ||
        message.includes('RetiredVersion')) {
        return;
    }
    originalWarn.apply(console, args);
};

console.error = (...args) => {
    const message = args.join(' ');
    // Google Maps 관련 에러 필터링
    if (message.includes('google.maps.Marker is deprecated') || 
        message.includes('google.maps.marker.AdvancedMarkerElement') ||
        message.includes('As of February 21st, 2024, google.maps.Marker is deprecated') ||
        message.includes('Google Maps JavaScript API warning: RetiredVersion') ||
        message.includes('RetiredVersion')) {
        return;
    }
    originalError.apply(console, args);
};

// async function enableMocking() {
//     const { worker } = await import('./mocks/browser')
//     return worker.start()
// }

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)
